import React, { useContext, useEffect } from 'react';
import { ResponsiveContainer } from 'recharts';
import { WatchForm } from '@components/WatchForm';
import { Refresh } from 'api/api';
import PriceRange from '@components/PriceRange';
import AuthContext from 'context/AuthContext';
import clsx from 'clsx';
import { useNavigate } from 'react-router-dom';

export const HomePage = () => {
  const navigate = useNavigate()
  useEffect(() => {
    const startTokenRefresh = () => {
      const interval = setInterval(() => {
        Refresh(navigate);
      }, 900000); // Refresh token every 15 minutes (900000 milliseconds)

      return () => clearInterval(interval);
    };
    startTokenRefresh();
  }, []);

  const { priceRange } = useContext(AuthContext);

  const minPrice = Number(priceRange[0]);

  const maxPrice = Number(priceRange[1]);

  return (
    <div className={clsx('grid', { 'grid-cols-2': minPrice && maxPrice, 'grid-cols-1': !minPrice || !maxPrice })}>
      {/* Desktop Layout */}
      <div className="hidden sm:block">
        <WatchForm />
      </div>
      {minPrice && maxPrice ? (
        <div className="bg-gray-bg mr-12 h-3/5 w-9/10 py-12 mt-40 hidden sm:block rounded-xl">
          <ResponsiveContainer width="100%" height="100%">
            <div className="mr-2">{PriceRange({ minValue: minPrice, maxValue: maxPrice })}</div>
          </ResponsiveContainer>
        </div>
      ) : null}
      {/* Mobile Layout */}
      <div className="col-span-2 sm:hidden">
        <WatchForm />
        {minPrice && maxPrice ? (
          <div className="bg-gray-bg h-1/4 w-full mx-auto py-5 mt-12 rounded-xl">
            <ResponsiveContainer width="95%" height="100%">
              {PriceRange({ minValue: minPrice, maxValue: maxPrice })}
            </ResponsiveContainer>
          </div>
        ) : null}
      </div>
    </div>
  );
};
